module.exports = __webpack_public_path__ + "img/144.f3b94045.jpg";